var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 14,
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 11,
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8889 21.6657C20.8889 19.4565 22.6789 17.6665 24.8898 17.6665C27.0972 17.6665 28.8889 19.4565 28.8889 21.6657C28.8889 23.8748 27.0972 25.6665 24.8898 25.6665C22.6789 25.6665 20.8889 23.8748 20.8889 21.6657Z",
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2222 33.6665V32.2845C18.4789 28.5897 21.3458 25.6665 24.8888 25.6665C28.4337 25.6665 31.3006 28.5897 31.5555 32.2845V33.6665",
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicInfo);
export default __webpack_public_path__ + "static/media/basicInfo.53d8edfb1c93c78453b82dae2367057f.svg";
export { ForwardRef as ReactComponent };